export default __webpack_public_path__ + "static/media/circle-border-primary.5955cdb4.svg";